import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-24 px-4 bg-dark-800 relative overflow-hidden" data-id="element-111">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="space-y-8 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-113">
          <p className="font-medium text-white border-l-4 border-amber-gold pl-6 py-1" data-id="element-114">
            Hay un tipo de cansancio que no viene de trabajar. Viene de pensar
            todo el día en lo que no hiciste.
          </p>

          <p data-id="element-115">
            Te levantas con una lista mental. No es larga. Ni siquiera es
            imposible. Pero tu cuerpo reacciona como si fuera peligro.
          </p>

          <p data-id="element-116">Y entonces empiezas el ritual:</p>

          <ul className="space-y-3 pl-6 text-amber-gold/90 font-medium italic" data-id="element-117">
            <li data-id="element-118">"Primero me organizo."</li>
            <li data-id="element-119">"Primero entiendo bien."</li>
            <li data-id="element-120">"Primero me calmo."</li>
            <li data-id="element-121">"Primero que alguien me confirme que voy por buen camino."</li>
          </ul>

          <p data-id="element-122">
            Y cuando te das cuenta… ya es tarde. No hiciste nada, pero quedaste
            agotado.
          </p>

          <div className="bg-dark-900/50 p-8 rounded-xl border border-white/5 mt-8" data-id="element-123">
            <p className="mb-4" data-id="element-124">
              Eso no es falta de ganas. Es{' '}
              <span className="text-amber-gold font-bold text-glow-amber-subtle" data-id="element-125">
                miedo diario
              </span>
              : una alarma interna que se activa cuando hay incertidumbre,
              cuando estás solo, y cuando existe la posibilidad de equivocarte.
            </p>

            <p className="text-white font-semibold" data-id="element-126">
              Este PDF existe para una sola cosa: que empieces hoy, aunque el
              miedo venga contigo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}